import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'raf/polyfill';

import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';

import 'config/option';
import './styles/app.css';

import i18nConfiguration from './i18n';
import createStore from './store/store';

import {CacheProvider} from '@emotion/react';
import createCache from '@emotion/cache';
import {StyledEngineProvider} from '@mui/material/styles';

// cat. build version
let BUILD_DATE = "20260611_044848";
let BUILD_VERSION = "3.3.3";
console.warn(BUILD_VERSION);
console.warn(BUILD_DATE);

const container = document.getElementById('into-app');
const root = createRoot(container);

root.render(<div/>);

const cache = createCache({key: 'mui', prepend: true});

i18nConfiguration(() => {
    import('./App').then(({default: App}) => {
        const store = createStore();

        root.render(
            <CacheProvider value={cache}>
                <StyledEngineProvider injectFirst>
                    <Provider store={store}>
                        <App/>
                    </Provider>
                </StyledEngineProvider>
            </CacheProvider>
        );
    });
});
